module.exports = {"disabled":"<strong>NB:</strong> This paymentmentmethod can be used up to a maximum of :%maximumAmount% per transaction"};